(function($, w) {
	
	// !-- Feature gate modal launch for jquery pages --
	this.FeatureGateInit = Class.extend({
		init: function (options)
		{
			this.planLevel 		  = options.planLevel;
			this.targetFeature  = options.targetFeature;
			this.titleString		= options.titleString;
      this.isFastspring		= options.isFastspring;
			this.listenerClass	= options.listenerClass
			this.listen();
		},
		
		listen: function()
		{
			var that = this;
		
			// Add click handler for listener class elements
			$(document).on('click', '.' + that.listenerClass, function(e) {
				e.preventDefault();

				// Initialize the modal if FeatureGateModal is available
				if (window.FeatureGateModal) {						
					// Create a container for the modal if it doesn't exist
					let modalContainer = document.getElementById('feature-gate-modal-container');
					if (!modalContainer) {
						modalContainer = document.createElement('div');
						modalContainer.id = 'feature-gate-modal-container';
						modalContainer.className = 'app-sv';
						document.body.appendChild(modalContainer);
					}
					
					// Create the modal instance with dynamic data
					const modal = new window.FeatureGateModal({
						target: modalContainer,
						props: {
							open: false,
							currentPlan: that.planLevel ?? 'basic',
							targetFeature: that.targetFeature,
							titleString: that.titleString,
							isFastspring: (that.isFastspring),
							close: function() {
								// Set open to false first, allowing reactive cleanup
								modal.$set({ open: false });
							}
						}
					});
					// Use setTimeout to trigger the open transition after component is mounted
					setTimeout(() => {
						modal.$set({ open: true });
					}, 200);
						
				}
			});	
		}
	});
	})(jQuery, window);